import BookingCalendar from '../calendar/bookingCalendar';

export default function Card_BookingCalendar() {
  return (
    <div className='text-card-foregroundshadow flex flex-grow flex-col rounded-lg border p-3 shadow dark:border-primary-foreground'>
      <BookingCalendar />
    </div>
  );
}
